import get from "lodash/get"

const styles = theme => ({
    root: {
        position: "relative",
        display: "block",
        height: "100vh",
        paddingTop: get(theme, "customTheme.sizes.appBarHeight"),
        backgroundColor: get(theme, "customTheme.white"),
    },

    logo: {
        width: "48px",
        height: "48px",
        background: "url(images/logo.png) center center / contain no-repeat",
    },

    swipeableCardsContainer: {
        width: `calc(100vw + 150px)`,
        maxWidth: `calc(100vw + 150px)`,
        height: `calc(100vh - ${get(theme, "customTheme.sizes.appBarHeight")} - ${get(theme, "customTheme.spacing.medium")} - 10px)`,
        padding: `0 ${get(theme, "customTheme.spacing.largest")} 0 0`,
        marginBottom: get(theme, "customTheme.spacing.smallest"),
    },

    imageContainer: {
        width: "100vw",
        height: `calc(100vh - ${get(theme, "customTheme.sizes.appBarHeight")} - ${get(theme, "customTheme.spacing.medium")} - 10px)`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
})

export default styles


// WEBPACK FOOTER //
// ./src/App/styles.js